<template>
  <section class="app-main">
     <el-breadcrumb class="route-menu" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index) in getRouterMenus" :key="index" :to="{ path: '/' }">{{item.meta&&item.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <transition
      name="fade"
      mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <router-view />
    </transition>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'AppMain',
  data(){
    return {
    }
  },
  computed:{
    ...mapGetters(['getRouterMenus'])
  }
};
</script>

<style lang="scss">
.app-main{
  padding:20px 22px;
      position: relative;
}
.route-menu{
      background-color: #ddd;
    position: relative;
    top: -20px;
    margin: 0 -22px;
    padding: 10px 0;
    padding-left: 24px;
}
</style>
